module.exports = __webpack_public_path__ + "static/media/12.993b2d7a.mp3";